<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-title><HomeButton/> Passwort zurücksetzen</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <form @submit="forgot">
        <ion-item lines="full">
          <ion-label position="floating">Email</ion-label>
          <ion-input type="email" v-model="email" required></ion-input>
        </ion-item>

        <ion-row>
          <ion-col>
            <ion-button type="submit" color="danger" expand="block">Absenden</ion-button>
          </ion-col>
        </ion-row>

        <small>
          Bitte geben Sie Ihre E-Mail-Adresse an, mit der Sie sich angemeldet haben.
        </small>
      </form>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonTitle,
  IonItem,
  IonPage,
  IonContent,
  IonHeader,
  IonRow,
  IonCol,
  IonButton,
  IonInput,
  IonLabel,
  IonButtons,
  IonBackButton,
  IonToolbar,
  toastController
} from '@ionic/vue'
import {defineComponent} from "vue";
import {useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import firebase from "firebase";
import HomeButton from "@/components/HomeButton.vue";

export default defineComponent({
  components: {
    HomeButton,
    IonTitle,
    IonItem,
    IonPage,
    IonContent,
    IonHeader,
    IonRow,
    IonCol,
    IonButton,
    IonInput,
    IonLabel,
    IonButtons,
    IonBackButton,
    IonToolbar
  },
  name: "ForgotPassword",
  methods: {
    async forgot(event: any) {
      event.preventDefault();
      console.log("test");
      try {

        const data = await firebase.auth().sendPasswordResetEmail(this.email)
        console.log(data);
        this.router.push({name: 'Login'});
        (await toastController.create({
          message: "Wir haben Ihnen eine E-Mail gesendet, mit der Sie Ihr Passwort zurück setzen könnnen",
          color: "success",
          position: "top",
          duration: 2000
        })).present();
      } catch (err) {
        console.log(` failed ${err}`);
        (await toastController.create({message: err.message, color: "danger", position: "top", duration: 2000})).present();
      }
    },
  },
  setup() {
    const router = useRouter()
    const i18n = useI18n()

    return {
      router,
      i18n,
      email: ""
    }
  }
})
</script>

<style scoped>

</style>